<template>
   <div class="register-box">
            <div class="register-main">
                <div class="left-box">
                    <div class="title-box">
                        <div class="left-title">选择您想找回密码的产品</div>
                        <div class="title-english">
                            CHOOSE YOUR PRODUCT
                    
                        </div>
                    </div>  
                    <div class="tabs flex-cen-cen-col">
                        <div v-for="(item,index) in project" :key="item" :class="'each-tab flex-cen-cen-col '+(nowindex==index?'active-tab':'')" @click="nowindex=index">
                           
                            <div class="tab-title flex-cen-cen">{{item.name}} </div>
                            <span class="tips">{{item.introduce}}</span>
                        </div>
 
                    </div>
                </div>
                <div class="right-register">
                  
                    <div class="erp" v-if="nowindex==0">

                        <div class="title">
                            <div id="fullname">找回华南冷库管理系统密码</div>
                        </div>

                    
                        <div class="item" style="margin-top:50px">
                            <div class="label">手机号</div>
                            <div class="input">
                                <input  v-model="zixun.mPhone" name="ctl00$ContentPlaceHolder1$txt_Phone" type="text" id="ContentPlaceHolder1_txt_Phone" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" onblur="CheckPhone(1);" maxlength="11" class="mobile value" placeholder="请输入手机号(必填)">
                            </div>
                            <div id="mobile_error" class="js-error" style="display: none;"></div>
                        </div>
                     
                        <input name="ctl00$ContentPlaceHolder1$txt_Show" type="hidden" id="ContentPlaceHolder1_txt_Show" class="mobile value" placeholder="是否显示">
                        <div class="item">
                            <div class="label">验证码</div>
                            <div class="input input-position input-sizing">
                                <input  v-model="zixun.mYzm"
            @blur="tocheck" name="ctl00$ContentPlaceHolder1$txt_code" type="text" id="ContentPlaceHolder1_txt_code" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" class="text code-value" maxlength="6" placeholder="请输入验证码" onblur="Checkyzm(1)" style="width: 100px;">
              <i
            v-if="isshowCheck"
            :style="
              'font-size:18px;color:' +
              (yzmOK == true ? 'green;' : 'red;')
            "
            :class="yzmOK ? 'el-icon-circle-check' : 'el-icon-circle-close'"
          ></i>
            <div class="get-code" id="getcode" v-bind:disabled="issend == true" @click="SendMsM">{{ issend ? "请稍后(" + lastTime + ")秒" : "获取短信验证码" }}</div>


                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="label">新密码</div>
                            <div class="input">
                                <input  v-model="zixun.newPass" name="ctl00$ContentPlaceHolder1$txt_Phone" type="text" id="ContentPlaceHolder1_txt_Phone" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" onblur="CheckPhone(1);" maxlength="11" class="mobile value" placeholder="请输入密码">
                            </div>
                            <div id="mobile_error" class="js-error" style="display: none;"></div>
                        </div>
                        
                        <div class="item">
                            <div class="label">再次输入</div>
                            <div class="input">
                                <input  v-model="zixun.rePass" name="ctl00$ContentPlaceHolder1$txt_Phone" type="text" id="ContentPlaceHolder1_txt_Phone" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')" onblur="CheckPhone(1);" maxlength="11" class="mobile value" placeholder="请再次输入">
                            </div>
                            <div id="mobile_error" class="js-error" style="display: none;"></div>
                        </div>
                        <!-- <div class="xieyi"> 
                            <input type="checkbox" id="ckbox">已阅读并同意<a href="https://www.wsgjp.com.cn/ServiceAgreement.aspx" target="_blank">《网上管家婆服务协议》</a>
                        </div> -->
                             <router-link style="
                color: blue;
                text-decoration: underline;
                text-align: center;
                width: 100%;
                display: block;
              " :to="{ path: '/dologin' }">
              前往登录?</router-link>
                        <div class="btn" > 


                             <div style="margin-top:20px" id="btn_Submit" class="button"  @click="sendZX()">提交信息</div>
                        </div>

                    </div>

                </div>



            </div>
        </div>
</template>
<script>
import { saveZixun, sendMsM, checkMsM, getLKUrl ,doSendCodeByPhone} from "@/api/index";

export default {
data() {
    return {
      zixun: {},
      lastTime: 0,
      issend: false,
      sign: "",
      yzmOK: false,
      nowindex:0,
      isshowCheck: false,
      project:[
          {
              type:'LK',
              name:'冷库管理系统',
              introduce:'South China cold storage'
          }
      ]
    };
  },
  methods: {
    tocheck() {
      const params = new URLSearchParams();
      params.append("phone", this.zixun.mPhone);
      params.append("code", this.zixun.mYzm);
      params.append("sign", this.sign);
      checkMsM(params)
        .then((e) => {
          if (e.data == true) {
            this.yzmOK = true;
            this.isshowCheck = true;
          }
        })
        .catch((e) => {
          this.yzmOK = false;
          this.isshowCheck = true;
        });
    },
    SendMsM() {
      var phone = this.zixun.mPhone;
      if (
        phone == undefined ||
        phone == null ||
        this.isPoneAvailable(phone) == false
      ) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请输入正确的手机号",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      const params = new URLSearchParams();
      params.append("phone", phone);

      //发送
      sendMsM(params).then((e) => {
        this.sign = e.msg;
        this.$notify({
          type: "success",
          title: "温馨提示",
          message: "发送成功，注意查收",
          duration: 5000,
          showClose: true,
        });
        this.issend = true;
        this.lastTime = 60;
        var int = self.setInterval((e) => {
          this.lastTime = this.lastTime - 1;
          if (this.lastTime == 0) {
            this.issend = false;
            clearTimeout(int);
          }
        }, 1000);
      });
    },
    isPoneAvailable($poneInput) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test($poneInput)) {
        return false;
      } else {
        return true;
      }
    },
    GetUrlParam(paraName) {
      var url = window.location.href.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    sendZX() {
      const params = new URLSearchParams();
   
          if (this.zixun.mYzm == null || this.zixun.mYzm == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写验证码",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      if (
        this.zixun.mPhone == undefined ||
        this.zixun.mPhone == null ||
        this.isPoneAvailable(this.zixun.mPhone) == false
      ) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请输入正确的手机号",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      params.append("phone", this.zixun.mPhone!=undefined?this.zixun.mPhone:'');
      params.append("code", this.zixun.mYzm);
      params.append("newPass", this.zixun.newPass);
      params.append("rePass",this.zixun.rePass);
      params.append("sign", this.sign);
      params.append("type", "LK");
      doSendCodeByPhone(params).then((e) => {
        if (this.project[this.nowindex].type == "LK") {
           var data = JSON.parse(e.msg);
          if (data.code != 0) {
            this.$notify({
              type: "error",
              title: "温馨提示",
              message: data.msg,
              duration: 5000,
              showClose: true,
            });
            this.dialogVisible = false;
            return ;
          }
            console.log(data);
        }
        this.$notify({
          type: "success",
          title: "温馨提示",
          message: "重置成功，请登录",
          duration: 2000,
          showClose: true,
        })
        setTimeout(function () {
         window.location.href=`/dologin`;
}, 2000);
   
        this.dialogVisible = false;
      }).catch(es=>{
          this.$notify({
          type: "error",
          title: "温馨提示",
          message: es,
          duration: 5000,
          showClose: true,
        });
      });
    },
  },
}
</script>
<style scoped>
body {
    margin: 0;
}

input {
    outline: 0px;
}
    input:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #FFF inset !important;
    }
.register-box {
    background: url(/img/bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height: 560px;
}
.disabled{
    background-color:rgb(160, 160, 160)!important;
}

.register-main {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    height: 470px;
    width: 710px;
}

.psi {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0 30px 0;
}

    .psi .title {
        font-weight: bold;
        font-size: 20px;
        display: flex;
        justify-content: center;
        margin-bottom: 14px;
        align-items: flex-end;
    }
.title div {
    font-family: 'SourceHanSansCN-Heavy';
}
.title #productname {
    font-size: 20px;
    font-weight: bold;
    color: #2861D2;
}

.erp {
    display: block;
    flex: 1;
    margin-top: 25px;
    padding: 10px 20px;
   
}
.input-sizing{
    width: 229px!important;
}

.erp .title {
    font-weight: bold;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 14px;
}
        .erp .title #fullname {
            font-size: 20px;
            color: #2861D2;
        }
    .erp .title a{
        font-weight: bold;
        font-size: 20px;
    }

.mini-title {
    font-size: 14px;
    margin-left: 6px;
    color: rgb(118,118,118);
}

.right-register {
    flex: 1;
    background-color: #ECF1FD;
    display: flex;
    justify-content: center;
    align-items: stretch;
}
.psi .input{
    width: 240px;
    height:36px;
    margin-left: 8px;
    box-sizing: border-box;
}
.input {
/*    padding: 0 6px;*/
    background-color: #fff;
    /*    margin-top: 6px;*/
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 230px;
/*    padding-right:9px;*/
}

    .input .get-code {
/*        width: 110px;*/
        color: #2962D2;
        font-size: 12px;
        margin-left:8px;
        padding-right:6px;
        cursor:pointer;
    }

    .input input {
        width: 120px;
        padding-left: 6px;
        height: 16px;
        border: 0;
        flex:1;
        height: 28px;
    }
.psi .xieyi {
    padding-left: 110px;
}
.xieyi {
    align-self: stretch;
    display: flex;
    align-items: center;
    font-size: 12px;
}
    .xieyi a {
        color: #2962D2;
        font-size: 12px;
        text-decoration: none;
    }

.code {
    width: 108px !important;
}
.psi .btn .button{
    height:30px;
    font-size: 16px;
    padding-left:30px;
    width:200px;
}
.btn {
    display: flex;
    justify-content: center;
    justify-self: flex-end;
    margin-top: 20px;
    cursor:pointer;
}
.erp .btn .button {
    height: 28px;
    font-size: 16px;
    width: 200px;
}
.space {
    letter-spacing: 24px;
}
.btn .button {
    width: 150px;
    /*display: flex;
    justify-content: center;*/
    align-items: center;
    color: #fff;
    height: 30px;
    line-height:30px;
    text-align:center;
    font-size: 14px;
    background-color: #2861D2;
    border: none;
    border-radius: 4px;
}
/*左侧*/
.left-box {
    display: flex;
    flex-direction: column;
    padding: 120px 0 90px 0px;
    box-sizing: border-box;
    align-items: center;
    background: url(/img/left-bg.png) no-repeat;
    background-size: 100% 100%;
    width: 265px;
    justify-content: space-between;
}

.left-title {
    font-size: 16px;
    color: #fff;
    margin-bottom: 6px;
}

.title-english {
    color: #fff;
    display: flex;
    font-size: 12px;
    opacity: 0.2;
    flex-direction: column;
    align-items: flex-start;
}

.flex-cen-cen-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.flex-cen-cen {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flex-between-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tabs {
   align-self:stretch;
}

.tab-title {
    font-weight: bold;
    font-size: 16px;
}

.each-tab {
    width: 245px;
    height: 50px;
    width: 100%;
    padding: 6px 0;
    cursor: pointer;
    box-sizing: border-box;
    border-top: 1px solid #396DCE;
}
.tab-title,.tips {
    color: #91B8FF
}

.tips {
    color: #62A2E4;
    font-size: 14px;
}

.active-tab {
    background:url(/img/choosed.png) no-repeat;
    background-size: 100% 100%;
    position:relative;
    width:102.4%;
    z-index:100;
    margin-left:7px;
    padding-right:7px;
    border-top:0;
}
    .active-tab  .tab-title, .active-tab  .tips{
        color: #fff;
    }

    .none {
        display: none;
    }

select {
    width: 200px;
    border: none;
    outline: 0px;
}

option {
    background-color: #fff;
}
a{
    text-decoration:none;
}
.psi menuitem {
    display: flex;
    align-items: center;
    background-color: #fff;
    margin-bottom: 20px;
    padding-left: 6px;
    border-radius: 4px;
    overflow: hidden
}

.psi .item .label {
    width: 45px;
    text-align: justify;
    text-align-last: justify;
}
.title-line {
    width: 1px;
    height: 20px;
    background-color: #3A3A3A;
    margin-left: 10px;
}
.psi .item{
/*    background-color:#fff;*/
}
.item {
    display: flex;
    align-items: center;
/*    background-color: #fff;*/
    margin-bottom: 20px;
    padding-left: 10px;
    justify-content:center;
    border-radius: 4px;
    /*    overflow: hidden;*/
    position: relative;
    height: 45px;
}
.psi .js-error {
    position: absolute;
    top: 42px;
    left: 50px;
    border-radius: 2px;
    color: #F27171;
    font-size: 14px;
    box-sizing: border-box;
}
.erp .item{
    height:28px;
}
.erp .item input{
    flex:1;
}
.erp .js-error {
    position: absolute;
    top: 28px;
    left: 10px;
    border-radius: 2px;
    color: #F27171;
    font-size: 12px;
    min-width:400px;
    text-align:center;
    box-sizing: border-box;
}

.erp .xieyi {
    margin-bottom: 10px;
    padding-left: 90px;
}
input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: rgb(160, 160, 160);
}
.input-position{
    box-sizing:border-box;
    height:32px;
}
.value:focus {
    outline: 1px solid #1B4EB2;
}

.item .label {
    width: 60px;
    margin-right: 12px;
    text-align: justify;
    text-align-last: justify;
    font-size:14px;
}

.select-box {
    width: 210px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

    .select-box img {
        width: 20px;
    }

.positon-r {
    position: relative;
}

.list {
    position: absolute;
    border-bottom: -40px;
    left: 100px;
}

</style>